export default "/documents/images/logo.png?8beb7a34751d2f21280ed4eacc76d9ba";